import { lazy as reactLazy } from 'react';

function lazy(fn, name) {
  const l = reactLazy(() => fn());
  l.displayName = name ? `LazyLoaded<${name}>` : 'LazyLoaded';
  return l;
}

export { default as Landing } from './Landing';
export const Login = lazy(() => import(/* webpackChunkName: 'login' */ './Login'), 'Login');
export const Logout = lazy(() => import(/* webpackChunkName: 'login' */ './Logout'), 'Logout');
export const Callback = lazy(
  () => import(/* webpackChunkName: 'login' */ './Callback'),
  'Callback'
);

// ADD YOUR NEW PAGES BELOW THIS LINE
export const ThreadViewer = lazy(
  () => import(/* webpackChunkName: 'assistant' */ './Assistant/ThreadViewer'),
  'ThreadViewer'
);

export const UniversalThreadCreator = lazy(
  () => import(/* webpackChunkName: 'assistant' */ './Assistant/UniversalThreadCreator'),
  'UniversalThreadCreator'
);

// Visitor Pages
export const BusinessCostVisitor = lazy(
  () => import(/* webpackChunkName: 'visitor' */ './BusinessCostVisitor'),
  'BusinessCostVisitor'
);

export const BusinessIdeaVisitor = lazy(
  () => import(/* webpackChunkName: 'visitor' */ './BusinessIdeaVisitor'),
  'BusinessIdeaVisitor'
);

export const BusinessNameVisitor = lazy(
  () => import(/* webpackChunkName: 'visitor' */ './BusinessNameVisitor'),
  'BusinessNameVisitor'
);

// Standalone Agent Framework
export const StandaloneVisitorPage = lazy(
  () => import(/* webpackChunkName: 'visitor' */ './StandaloneVisitorPage'),
  'StandaloneVisitorPage'
);

export const VisitorThreadCreator = lazy(
  () => import(/* webpackChunkName: 'assistant' */ './Assistant/VisitorThreadCreator'),
  'VisitorThreadCreator'
);

export const VisitorThreadViewer = lazy(
  () => import(/* webpackChunkName: 'assistant' */ './Assistant/VisitorThreadViewer'),
  'VisitorThreadViewer'
);

// Test Pages - Development only
export const VeloCardTest = lazy(
  () => import(/* webpackChunkName: 'test' */ './test/VeloCardTest'),
  'VeloCardTest'
);

export const ChartsTest = lazy(
  () => import(/* webpackChunkName: 'test' */ './test/ChartsTest'),
  'ChartsTest'
);
